import React, { useEffect, useState } from "react";
import { ChoosePlanContainer } from "./style";
import Plan from "../../plan";
import { BoxLoading } from "../../../../../components/loading";
import { PURCHASE_STEPS_TYPE } from "../../../../../constants/purchase";
import ErrorHandle from "../../../../../components/error/mainError";

const ChoosePlan = props => {
  const {
    data,
    calculatePrice,
    buyGift,
    loading,
    buyGiftLoading,
    fetchNecessaryRequest,
    mainLoading,
    formStep,
    error
  } = props;
  const plans = data.data;
  const [clickedPlan, setClickedPlan] = useState(-1);
  const [plansSelectedDurationId, setPlansSelectedDurationId] = useState([]);
  const renderCondition = formStep === PURCHASE_STEPS_TYPE.CHOOSE_PLAN;
  useEffect(() => {
    if (renderCondition) {
      fetchNecessaryRequest();
    }
  }, [renderCondition]);
  useEffect(() => {
    if (renderCondition) {
      const plansSelectedDurations = plans.map(plan => {
        const durations = plan.durations;
        const selectedDurationId = data.selected_duration;
        const selectedDurationIndex = durations.length - 1;
        let selectedDuration = [];
        if (selectedDurationId) {
          selectedDuration = durations.filter(
            dur => dur.id === selectedDurationId
          );
        }
        if (selectedDuration.length <= 0) {
          selectedDuration = durations.filter(
            (dur, i) => i === selectedDurationIndex
          );
        }
        if (selectedDuration.length > 0) {
          return selectedDuration[0].id;
        } else {
          return -1;
        }
      });
      setPlansSelectedDurationId(plansSelectedDurations);
    }
  }, [plans]);

  if (renderCondition)
    return (
      <React.Fragment>
        {(mainLoading || buyGiftLoading) && <BoxLoading />}
        {!mainLoading && plans && !error && (
          <ChoosePlanContainer childrenCounts={plans.length}>
            {plans.length > 0 &&
              plans.map((plan, i) => {
                return (
                  <Plan
                    key={i}
                    data={plan}
                    selectedDuration={plansSelectedDurationId[i]}
                    setSelectedDuration={data => {
                      const newPlansSelectedDurationId = [
                        ...plansSelectedDurationId
                      ];
                      newPlansSelectedDurationId[i] = data;
                      setPlansSelectedDurationId(newPlansSelectedDurationId);
                    }}
                    calculatePrice={calculatePrice}
                    buyGift={buyGift}
                    loading={loading}
                    clickedPlan={clickedPlan}
                    setClickedPlan={setClickedPlan}
                    trial_flag={data.trial_flag}
                  />
                );
              })}
          </ChoosePlanContainer>
        )}
        <ErrorHandle message={error} request={fetchNecessaryRequest} />
      </React.Fragment>
    );
  else {
    return null;
  }
};

export default ChoosePlan;
